import { render, staticRenderFns } from "./ModulIncomeExpenses.vue?vue&type=template&id=53379916&"
import script from "./ModulIncomeExpenses.vue?vue&type=script&lang=js&"
export * from "./ModulIncomeExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports